import { ITask } from '@modules/TasksModule/types';
import { phoneState } from '../state';

function handleTaskAccept(task: ITask): void {
  const newCallsAccepting = [...phoneState.callsAccepting];
  newCallsAccepting.push(task.attributes.callId);
  phoneState.callsAccepting = newCallsAccepting;
}

export default handleTaskAccept;
